import { API_URL } from '../config/config';
import { getRequest } from '../utils/axiosUtils';
import buildQueryParams from '../utils/buildQueryParams';

/**
 * Signup Report data — users grouped by their signup day (createdAt) and counted
 * by their CURRENT state. Returns { totals, byDate, byCity, byCountry }.
 * The date range / country / state / city / gender filters all scope the signup
 * population; omit the date range for all-time.
 */
export const getSignupReport = async (filter) => {
  const { country, state, city, dateRange, gender, utm_payload } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/getSignupReport?${queryParams}`,
    isAbort: false,
  });
  if (!res) return null;
  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};
